export default __webpack_public_path__ + "src/images/bg_menu-e8477a.png";